<!--  SECCION BANNERS -->
<div class="d-none d-md-block">
  <div id="carouselBC" class="carousel slide" data-ride="carousel">

    <ol class="carousel-indicators" *ngIf="banners.length > 1">
      <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
          [ngClass]="(i === 0) ? 'active' : 'inactive'"></li>
    </ol>

    <!-- ------------------DETALLE PROMOCION >= Long-Devices ----------------------->
    <div class="carousel-inner d-none d-lg-block">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
           [ngStyle]="{background: 'url(' + banner.urlImagen +')', 'background-repeat': 'no-repeat', 'background-size': '100% 100%'}"
           [ngClass]="(i === 0) ? 'active' : 'inactive'"
           [routerLink]="banner.mostrarRecBanner!==1 ? ['/showPromo',banner.idPromocion,selectedIdCard,currentPage] : null"
           [title]="getInnerHTML(banner.nombre)" [attr.dir]="'https://promocionesbancoppel.com/showPromo/'+banner.idPromocion+'/'+selectedIdCard+'/'+currentPage" [attr.content]="banner.urlImagen">
        <div class="container" [ngStyle]="{'cursor': banner.mostrarRecBanner!==1 ? 'pointer' : '' }">
          <div class="row">
            <div class="col-1"></div>

            <div class="col-5">
              <div class="row" style="height: 400px;">
                <div class="col-12" style="padding-top: 11%;" *ngIf="banner.mostrarRecBanner===1">
                  <div class="row p-20 text-left d-flex align-items-center"
                       style="height: 57%; background-color: #125BA8;">
                    <!-- <div class="col-12"><p class="promo-name" [innerHTML]="banner.nombre"></p></div> -->
                    <div class="col-12 promo-name-banner justify-content-center text-left" [innerHTML]="banner.nombreBanner">
                    </div>
                  </div>
                  <div class="row p-20 d-flex align-items-center" style="height: 21%; background-color: #ffffff;">
                    <div class="col-6 text-center">
                      <img src="{{banner.comercio.urlLogoImagenBanner}}" width="125" height="50">
                    </div>
                    <div class="col-6 text-center">
                      <button type="button" class="btn btn-primary banner-show-button" style="background-color: #125BA8"
                              [routerLink]="['/showPromo',banner.idPromocion,selectedIdCard,currentPage]">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ver m&aacute;s&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------END---------DETALLE PROMOCION >= Long-Devices ----------------------->
    <!-- ------------------DETALLE PROMOCION == Medium-Devices ----------------------->
    <div class="carousel-inner d-none d-md-block d-lg-none">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
           [ngStyle]="{background: 'url(' + banner.urlImagenTablet +')', 'background-repeat': 'no-repeat', 'background-size': '100% 100%'}"
           [ngClass]="(i === 0) ? 'active' : 'inactive'"
           [routerLink]="banner.mostrarRecBanner!==1 ? ['/showPromo',banner.idPromocion,selectedIdCard,currentPage] : null"
           [title]="getInnerHTML(banner.nombre)" [attr.dir]="'https://promocionesbancoppel.com/showPromo/'+banner.idPromocion+'/'+selectedIdCard+'/'+currentPage" [attr.content]="banner.urlImagen">
        <div class="container">
          <div class="row">
            <div class="col-1"></div>

            <div class="col-5">
              <div class="row" style="height: 400px;">
                <div class="col-12" style="padding-top: 11%;" *ngIf="banner.mostrarRecBanner===1">
                  <div class="row p-20 text-left d-flex align-items-center"
                       style="height: 57%; background-color: #125BA8;">
                    <!-- <div class="col-12"><p class="promo-name" [innerHTML]="banner.nombre"></p></div> -->
                    <div class="col-12 promo-name-banner justify-content-center text-left" [innerHTML]="banner.nombreBanner">
                    </div>
                  </div>
                  <div class="row p-20 d-flex align-items-center" style="height: 21%; background-color: #ffffff;">
                    <div class="col-6 text-center">
                      <img src="{{banner.comercio.urlLogoImagenBanner}}" width="125" height="50">
                    </div>
                    <div class="col-6 text-center">
                      <button type="button" class="btn btn-primary banner-show-button" style="background-color: #125BA8"
                              [routerLink]="['/showPromo',banner.idPromocion,selectedIdCard,currentPage]">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ver m&aacute;s&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------END---------DETALLE PROMOCION == Medium-Devices ----------------------->

    <!--<div class="container d-none d-lg-block" *ngIf="banners.length > 1">
      <a class="carousel-control-prev" href="#carouselBC" role="button" data-slide="prev" style="left: -8%;">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselBC" role="button" data-slide="next" style="right: -8%;">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>-->

   <!-- <div class="container d-block d-lg-none" *ngIf="banners.length > 1">
      <a class="carousel-control-prev" href="#carouselBC" role="button" data-slide="prev" style="left: -4%;">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselBC" role="button" data-slide="next" style="right: -4%;">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>-->

  </div>

</div>



<!-- ------------------DETALLE PROMOCION == Small-Devices ----------------------->
<div class="d-none d-sm-block d-md-none">
  <div id="carouselBC" class="carousel slide" data-ride="carousel" style="height: 350px;">

    <ol class="carousel-indicators">
      <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
          [ngClass]="(i === 0) ? 'active' : 'inactive'"></li>
    </ol>


    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
           [ngStyle]="{background: 'url(' + banner.urlImagenMovil +')', 'background-repeat': 'no-repeat', 'background-size': '100% 90%'}"
           [ngClass]="(i === 0) ? 'active' : 'inactive'"
           [routerLink]="banner.mostrarRecBanner!==1 ? ['/showPromo',banner.idPromocion,selectedIdCard,currentPage] : null"
           [title]="getInnerHTML(banner.nombre)" [attr.dir]="'https://promocionesbancoppel.com/showPromo/'+banner.idPromocion+'/'+selectedIdCard+'/'+currentPage" [attr.content]="banner.urlImagen">

        <div class="container">
          <div class="row">

            <div class="col-6">
              <div class="row" style="height: 400px;">
                <div class="col-12" style="padding-top: 11%;" *ngIf="banner.mostrarRecBanner===1">
                  <div class="row p-20 text-left d-flex align-items-center"
                       style="height: 57%; background-color: #125BA8;">
                    <!-- <div class="col-12"><p class="promo-name" [innerHTML]="banner.nombre"></p></div> -->
                    <div class="col-12 promo-name-mobile-banner justify-content-center text-left" [innerHTML]="getMobileFormat(banner.nombreBanner)">
                    </div>
                  </div>
                  <div class="row p-20 d-flex align-items-center" style="height: 21%; background-color: #ffffff;">
                    <div class="col-6 text-center"><img src="{{banner.comercio.urlLogoImagenBanner}}" width="87"
                                                        height="35"></div>
                    <div class="col-6 text-center">
                      <button type="button" class="btn btn-primary banner-show-button text-center" style="background-color: #125BA8"
                              [routerLink]="['/showPromo',banner.idPromocion,selectedIdCard,1]">
                        &nbsp;Ver m&aacute;s&nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6"></div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
<!--  ENDS SECCION  BANNERS-->


<!-- ------------------SECCION  BANNERS-- == Xtra-Small-Devices ----------------------->
<div class="d-block d-sm-none">
  <div id="carouselBC" class="carousel slide" data-ride="carousel" style="height: 380px;">

    <ol class="carousel-indicators">
      <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
          [ngClass]="(i === 0) ? 'active' : 'inactive'"></li>
    </ol>


    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
           [ngStyle]="{background: 'url(' + banner.urlImagenMovil +')', 'background-repeat': 'no-repeat', 'background-size': '100% 95%'}"
           [ngClass]="(i === 0) ? 'active' : 'inactive'"
           [routerLink]="banner.mostrarRecBanner!==1 ? ['/showPromo',banner.idPromocion,selectedIdCard,currentPage] : null"
           [title]="getInnerHTML(banner.nombre)" [attr.dir]="'https://promocionesbancoppel.com/showPromo/'+banner.idPromocion+'/'+selectedIdCard+'/'+currentPage" [attr.content]="banner.urlImagen">

        <div class="container">
          <div class="row">

            <div class="col-6">
              <div class="row" style="height: 400px;">
                <div class="col-12" style="padding-top: 11%;" *ngIf="banner.mostrarRecBanner===1">
                  <div class="row p-20 text-left d-flex align-items-center"
                       style="height: 57%; background-color: #125BA8;">
                    <!-- <div class="col-12"><p class="promo-name" [innerHTML]="banner.nombre"></p></div> -->
                    <div class="col-12 promo-name-xsmobile-banner justify-content-center text-left" [innerHTML]="getXSMobileFormat(banner.nombreBanner)">
                    </div>
                  </div>
                  <div class="row p-20 d-flex align-items-center" style="height: 21%; background-color: #ffffff;">
                    <div class="col-6 text-center"><img src="{{banner.comercio.urlLogoImagenBanner}}" width="77"
                                                        height="28"></div>
                    <div class="col-6 text-center">
                      <button type="button" class="btn btn-primary banner-show-button text-center" style="background-color: #125BA8"
                              [routerLink]="['/showPromo',banner.idPromocion,selectedIdCard,1]">
                        &nbsp;Ver m&aacute;s&nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6"></div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
<!--  ENDS SECCION  BANNERS-->


